<template>
    <div class="material_block">
        <svg
            class="spinner"
            width="96px"
            height="96px"
            viewBox="0 0 66 66"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                fill="none"
                stroke="rgba(0, 185, 255, 0.2)"
                stroke-width="6"
                stroke-linecap="round"
                cx="33"
                cy="33"
                r="30"
            ></circle>
            <circle
                class="circle"
                fill="none"
                stroke-width="6"
                stroke-linecap="round"
                cx="33"
                cy="33"
                r="30"
            ></circle>
        </svg>
    </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class Spinner extends Vue {}
</script>

<style scoped lang="less">
.material_block {
    height: 143px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
}

.spinner {
    animation: rotation 1.35s linear infinite;
}

@-webkit-keyframes rotation {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(270deg);
    }
}

@keyframes rotation {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(270deg);
    }
}

.circle {
    stroke-dasharray: 180;
    stroke-dashoffset: 0;
    transform-origin: center;
    animation: turn 1.35s ease-in-out infinite;
}

@keyframes turn {
    0% {
        stroke-dashoffset: 180;
    }

    50% {
        stroke-dashoffset: 45;
        transform: rotate(135deg);
    }

    100% {
        stroke-dashoffset: 180;
        transform: rotate(450deg);
    }
}

svg:nth-child(1) {
    stroke: #00b9ff;
}
</style>
